export default "__VITE_ASSET__BwiBB48t__"